export const css = {
    root: 'egzJWd2u',
    extended: '_1EnozsjK',
    small: '_1iQHRu78',
    pressed: '_1RsFXuMp _25bT9jgN',
    label: '_1UzWn1lq _18Q0dUhR',
    disabled: '_2T4gGtBW',
    ' _key': 'afcpe-theme/dojo/floating-action-button'
};
export default css;
